// extracted by mini-css-extract-plugin
module.exports = {"container":"Overview_container__25D93","left_component":"Overview_left_component__3wbJF","right_component":"Overview_right_component__3ZseN"};